var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1285 17.2842L8.15072 6.98657L6.04193 4.81228L5 5.85421L7.29761 8.15155V8.15977C6.87065 8.97232 6.641 9.93231 6.641 10.966V15.0685L5 16.7098V17.5303H16.2658L17.9068 19.1713L18.949 18.1293L18.1285 17.2842ZM11.5643 20C11.78 20.0007 11.9937 19.9588 12.1931 19.8766C12.3926 19.7944 12.5738 19.6736 12.7263 19.521C12.8788 19.3685 12.9997 19.1873 13.0819 18.9879C13.1641 18.7884 13.206 18.5747 13.2053 18.359H9.92299C9.92227 18.5747 9.96423 18.7885 10.0465 18.9879C10.1287 19.1873 10.2496 19.3685 10.4021 19.5211C10.5547 19.6736 10.7359 19.7944 10.9353 19.8766C11.1348 19.9588 11.3485 20.0007 11.5643 20ZM16.4873 13.9937V10.9742C16.4873 8.44697 15.1417 6.3464 12.795 5.78871V5.23047C12.7952 5.06881 12.7635 4.9087 12.7017 4.75932C12.6399 4.60993 12.5492 4.4742 12.4349 4.3599C12.3206 4.2456 12.1848 4.15498 12.0354 4.09322C11.886 4.03146 11.7259 3.99978 11.5643 4C11.4026 3.99978 11.2425 4.03146 11.0931 4.09322C10.9437 4.15498 10.8079 4.2456 10.6936 4.3599C10.5793 4.4742 10.4886 4.60993 10.4268 4.75932C10.365 4.9087 10.3333 5.06881 10.3335 5.23047V5.78871C10.2102 5.81337 10.0954 5.85421 9.98876 5.88709C9.90655 5.91176 9.82461 5.94464 9.74267 5.97753H9.73444C9.72622 5.97753 9.72622 5.97753 9.718 5.98548C9.52918 6.05947 9.34064 6.14963 9.16004 6.23979C9.16004 6.23979 9.15182 6.23979 9.15182 6.24801L16.4873 13.9937Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsOff);
export default __webpack_public_path__ + "static/media/notifications_off.8922338f429f2d66a0f3b1f5cc0abcf5.svg";
export { ForwardRef as ReactComponent };